import { Button } from "@mui/material";
import {
  Input,
  MuiBox,
  MuiTypography,
  SubmitLoaderButton,
} from "components/atoms";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import * as Yup from "yup";
// import {
//   ChangePasswordAction,
//   SetSecondPasswordAction,
// } from "store/middlewares/settings/profile";
import { useTranslation } from "react-i18next";
import { VPassword } from "utils/validation/CommonValidation";
import {
  LockUnlockFileFolderAction,
  VerifySecureFileFolderAction,
} from "store/middlewares/general";

const VerifyPassword = ({
  onClose,
  onNavigate,
  payload,
  successFunction,
  clearSelection,
  description = null,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    const onSuccess = () => {
      if (successFunction) {
        successFunction?.();
        return;
      }
      if (payload) {
        dispatch(
          LockUnlockFileFolderAction({
            ...payload,
            ...values,
            onSuccess: () => {
              clearSelection?.();
              onClose?.();
              setLoading(false);
            },
            onError: () => setLoading(false),
          }),
        );
      } else {
        onNavigate?.();
      }
    };

    dispatch(
      VerifySecureFileFolderAction({
        ...values,
        onSuccess,
        onError: (message) => {
          setLoading(false);
          formik.setFieldError("password", message);
        },
      }),
    );

    console.log({ ...payload, ...values });
  };

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: Yup.object({
      password: VPassword(t),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <MuiBox component={"form"} onSubmit={formik.handleSubmit}>
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          p: "24px",
        }}
      >
        <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
            {t("modal.allPassword.verifyPassword")}
          </MuiTypography>
          <MuiTypography
            variant="14"
            fontWeight={"400"}
            sx={{ color: "text.lightgray", wordBreak: "break-word" }}
          >
            {description ??
              (payload?.action === "secure"
                ? t("modal.allPassword.enterYourPasswordToLockThisFileFolder")
                : t("modal.allPassword.enterYourPasswordToUnlockThisFileFolder"))}
          </MuiTypography>
        </MuiBox>
        <Input
          label={t("modal.allPassword.password")}
          type="password"
          placeholder={t("modal.allPassword.enterPassword")}
          name={"password"}
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMsg={formik.errors.password}
          error={formik.touched.password && formik.errors.password}
          isBorderColor={true}
        />
      </MuiBox>
      <MuiBox
        sx={{
          display: "flex",
          gap: "12px",
          justifyContent: "end",
          backgroundColor: "background.gray200",
          p: "16px 24px",
        }}
      >
        <Button
          variant="whiteContained"
          onClick={() => {
            dispatch(closeCenterModal());
            onCancel?.();
          }}
        >
          {t("commonButton.cancel")}
        </Button>
        <SubmitLoaderButton
          variant="blueContained"
          btnText={t("modal.allPassword.confirm")}
          isDisable={loading}
          isLoading={loading}
          type="submit"
        />
      </MuiBox>
    </MuiBox>
  );
};

export default VerifyPassword;
